<template>
    <div>
        <pdf :src="pdfPath"></pdf>
    </div>
</template>

<script>

import pdf from 'vue-pdf';

export default {
    components: {
        pdf
    },
    data() {
        return {
            pdfPath: 'https://pan.letmecode.cn/407bc7cfd42bb03eccf19975f6d3efb4.pdf' // 替换为实际的PDF文件路径
        }
    }
}
</script>
